export default {
    watch: {
        '$i18n.locale'() {
            this.updateDocumentTitle();
        }
    },
    methods: {
        updateDocumentTitle() {
            if (this.seo_title && this.seo_title_data) {
                document.title = this.$t(this.seo_title, this.seo_title_data);
            } else if (this.seo_title) {
                document.title = this.$t(this.seo_title);
            }
        }
    },
    mounted() {
        this.updateDocumentTitle();
    }
};
